<template>
  <div class="course-content" :style="courseStyleObject">
    <div class="course-cate" v-if="!hideType">
      <div class="cate-row flex-fs">
        <span>课程类型:</span>
        <ul class="flex-fs">
          <li
            @click="getCourseData('courseType', '')"
            :class="{ current: CourseObj.courseType == '' }"
          >
            全部
          </li>
          <li
            :class="{ current: CourseObj.courseType == item.dictValue }"
            @click="getCourseData('courseType', item.dictValue)"
            v-for="item in courseTypeList"
          >
            {{ item.dictLabel }}
          </li>
        </ul>
      </div>
      <div class="cate-row flex-fs">
        <span>专业目录:</span>
        <ul class="flex-fs">
          <li
            @click="getCourseData('courseMajor', '')"
            :class="{ current: CourseObj.courseMajor == '' }"
          >
            全部
          </li>
          <li
            :class="{ current: CourseObj.courseMajor == item.dictValue }"
            v-for="item in catalogueList"
            @click="getCourseData('courseMajor', item.dictValue)"
          >
            {{ item.dictLabel }}
          </li>
        </ul>
      </div>
    </div>
    <div class="course-list flex-fs">
      <div
        class="course-list-item"
        :class="{ three: hideType }"
        v-for="item in courseList"
      >
        <div
          class="item-img"

          @click="toDetails(item.courseId)"
        >
          <img :src="getFullImageUrl(item.coursePic)"  />
        </div>
        <div class="title">
          {{ item.courseTitle }}
        </div>
        <div class="star-view">
          <span
            v-if="
              !isCollection(item.courseId) &&
              !handelCollect.includes(item.courseId)
            "
            @click="requestCollect(item.courseId)"
          >
            <i class="el-icon-star-off"></i>

            {{ item.collectNum }}</span
          >
          <span v-else @click="cancelCollect(item.courseId)">
            <i
              style="color: #ffba42; font-size: 20px"
              class="el-icon-star-on"
            ></i>
            {{ item.collectNum }}</span
          >

          <span><i class="el-icon-view"></i> {{ item.courseClick }}</span>
        </div>
      </div>
    </div>
    <div
      class="pages flex-cc"
      :style="styleObject"
      v-if="hideType && courseTotal > 9"
    >
      <el-pagination
        @current-change="changePage"
        :page-size="9"
        :page-sizes="[]"
        background
        layout="prev, pager, next"
        :total="courseTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { collect, getCollectIds } from "@/api";
import axios from "axios";
export default {
  name: "Course",
  props: {
    courseTypeList: Array,
    catalogueList: Array,
    courseList: Array,
    courseTotal: Number,
    styleObject: Object,
    courseStyleObject: Object,
    hideType: Boolean, //我的收藏不展示
  },
  data() {
    return {
      handelCollect: [],
      CourseObj: {
        courseType: "",
        courseMajor: "",
        pageSize: "12",
        pageNum: 1,
      },
    };
  },

  methods: {
    //分页
    changePage(val) {
      this.CourseObj.pageNum = val;

      if (this.hideType) {
        this.$emit("getCourseData", val);
      } else {
        this.$emit("getCourseData", this.CourseObj);
      }
    },
    getCourseData(type, key) {
      if (type == "courseType") {
        this.CourseObj.courseType = key;
      } else {
        this.CourseObj.courseMajor = key;
      }
      this.$emit("getCourseData", this.CourseObj);
    },
    requestCollect(courseId) {
      if (!localStorage.getItem("token")) {
        return this.errorTips("登录状态失效，请重新登录");
      }
      collect({ courseId }).then((res) => {
        if (res.code == 200) {
          this.requestGetCollectIds();
          this.handelCollect.push(courseId);
          this.$notify({
            title: "提示",
            message: "收藏成功",
            type: "success",
          });
        }
      });
    },
    cancelCollect(courseId) {
      axios
        .delete(`${process.env.VUE_APP_BASE_URL}/prod-api/web/collect/${courseId}`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.requestGetCollectIds();
            let arr = JSON.parse(JSON.stringify(this.handelCollect));
            arr = arr.filter(function (value) {
              return value != courseId;
            });

            setTimeout(() => {
              this.handelCollect = arr;
            }, 200);
            if (this.hideType) {
              //取消收藏重新获取
              this.$emit("handleCancel");
            }

            this.errorTips("取消收藏成功", "success");
          }
        });
    },
    toDetails(courseId) {
      if (!localStorage.getItem("token")) {
        return this.errorTips("登录状态失效，请重新登录");
      }
      this.$router.push({
        path: "/courseDes",
        query: { courseId },
      });
    },
    errorTips(message, type = "warning") {
      this.$notify({
        title: "提示",
        message,
        type,
      });
    },
    requestGetCollectIds() {
      getCollectIds().then((res) => {
        this.collectArr = res.data;

        localStorage.setItem("collectArr", JSON.stringify(res.data));
      });
    },
    isCollection(key) {
      if (localStorage.getItem("token") && localStorage.getItem("collectArr")) {
        let collectArr = JSON.parse(localStorage.getItem("collectArr"));

        return collectArr.includes(key);
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.course-content {
  background: #f3f4f8;
  padding: 45px 45px 72px 45px;

  .course-cate {
    font-size: 16px;
    color: #000;
    .cate-row {
      margin-bottom: 22px;
    }
    ul {
      padding-left: 18px;
      li {
        margin-right: 32px;
        padding: 0 4px 3px;
        cursor: pointer;
        border-bottom: 3px solid #f3f4f8;
        &:hover {
          color: #1265cc;
          border-bottom: 3px solid #1265cc;
        }
        &.current {
          color: #1265cc;
          border-bottom: 3px solid #1265cc;
        }
      }
    }
  }

  .course-list {
    padding-top: 26px;
    flex-wrap: wrap;
    &-item {
      border: 1px solid #eeeeee;
      position: relative;
      width: 332px;
      height: 320px;
      background: #fff;
      margin-bottom: 60px;
      margin-left: 60px;
      cursor: pointer;
      &:nth-child(4n + 1) {
        margin-left: 0;
      }
      &.three:nth-child(3n + 1) {
        margin-left: 0;
      }

      .item-img {
        overflow: hidden;
        height: 220px;
        background: #eee;
        background-size: cover;
        img {
          width: 100%;
          height: 220px;
        }
      }
      .title {
        padding: 16px 15px 0;
        font-size: 16px;
        color: #000;
      }
      .star-view {
        color: #939393;
        font-size: 14ox;
        position: absolute;
        bottom: 12px;
        right: 14px;
        i {
          font-size: 16px;
        }
        span {
          padding-left: 32px;
        }
      }
    }
  }
}
</style>
